var inherits = require('util').inherits,
    ReadableStream = require('stream').Readable || require('readable-stream');

function PartStream(opts) {
  ReadableStream.call(this, opts);
}
inherits(PartStream, ReadableStream);

PartStream.prototype._read = function(n) {};

module.exports = PartStream;



//////////////////
// WEBPACK FOOTER
// ./node_modules/dicer/lib/PartStream.js
// module id = 1337
// module chunks = 7